import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFullScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M443.5 162.58h-10.92V79.42h-83.16V68.5h94.08zM79.42 162.58H68.5V68.5h94.08v10.92H79.42zM162.58 443.5H68.5v-94.08h10.92v83.16h83.16zM443.5 443.5h-94.08v-10.92h83.16v-83.16h10.92z"
    />
    <path
      fill="#242323"
      d="m306.02 313.743 7.722-7.722 128.156 128.156-7.721 7.722zM70.1 77.823l7.72-7.722 128.157 128.156-7.722 7.722zM70.1 434.178l128.156-128.156 7.721 7.721L77.821 441.9zM306.02 198.257 434.176 70.1l7.721 7.721-128.156 128.156z"
    />
  </svg>
);
export default SvgIconFullScreen;
